import React, { FC, memo } from 'react';
import { Container } from './styles';
import { Props } from './types';

const TextWrap: FC<Props> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default memo(TextWrap);
